import React, { useEffect, useRef, useState, useContext } from 'react';
import { Card, Col, Container, Form, InputGroup, Row } from 'react-bootstrap';
import ViewMoreButtonDesktop, { ViewMoreButtonMobile } from "../WebButton/ViewMoreButton";
import { useParams } from 'react-router-dom';
import './Article.css';
import HorizontalAd from '../Ads/HorizontalAd';
import RealtedArticel from '../RelatedArticel/RelatedArticel';
import WhiteStorieCard from '../StorieCards/White/WhiteStorieCard';
import { useAppContext } from '../Context/AppContext';
import Cookies from 'js-cookie';
import parse from 'html-react-parser';
import Meta from '../Meta/Meta';
import Share from '../Share/Share';

const Article = () => {
    if (!Cookies.get('lg')) {
        Cookies.set('lg', 'en');
    }

    const { BASE_PATH } = useContext(useAppContext);
    const [isLoading, setIsLoading] = useState(true);
    const [data, setData] = useState(null);
    const [relatedtitle] = useState("Related Articles");
    const [trendingtitle] = useState("Trending");

    const { articlename } = useParams();
    const [relativeTime, setRelativeTime] = useState("");
const [reactions, setReactions] = useState({
  love: 0,
  laugh: 0,
  surprised: 0,
  sad: 0,
  angry: 0
});
    const commentref = useRef();

    const videoCategories = [
        'videos', 'paparazzi', 'trailers', 'वीडियोस', 'पेप्पराज़ी', 'ट्रेलर',
        'వీడియోస్', 'ఫిల్మ్-ఈవెంట్స్', 'ట్రైలర్స్', 'RJ-Suneetha-కబుర్లు', 'numerology'
    ];
const lang = Cookies.get("lg") || "en";
    const fetchData = async () => {
        try {
            const response = await fetch(
                `/api/${lang}/article`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ articlename: articlename })
            });

            if (!response.ok) throw new Error(`HTTP ${response.status}`);

            const result = await response.json();
            console.log("✅ Article API Response:", result);

            if (result.status === 1) {
                setData(result.data);
            }
        } catch (err) {
            console.error("❌ Fetch Error:", err);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (articlename) {
            setIsLoading(true);
            fetchData();
            window.scrollTo(0, 0);
        }
    }, [articlename]);

    // Calculate relative time
    useEffect(() => {
        if (data?.articledata?.date || data?.article?.date) {
            const articleDate = new Date(data.articledata?.date || data.article?.date);
            const now = new Date();
            const diff = Math.floor((now - articleDate) / 1000);

            let timeStr = '';
            if (diff < 60) timeStr = `${diff} seconds ago`;
            else if (diff < 3600) timeStr = `${Math.floor(diff / 60)} minutes ago`;
            else if (diff < 86400) timeStr = `${Math.floor(diff / 3600)} hours ago`;
            else timeStr = `${Math.floor(diff / 86400)} days ago`;

            setRelativeTime(timeStr);
        }
    }, [data]);

const handleReaction = (type) => {
  setReactions(prev => ({
    ...prev,
    [type]: prev[type] + 1
  }));
};
    const sendComment = async () => {
        if (!commentref.current?.value || !data) return;

        try {
            const res = await fetch('/api/post-comment', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    postid: data.articledata?.postid || data.article?.postid,
                    categorytitle: data.articledata?.categorytitle || data.article?.categorytitle,
                    comment: commentref.current.value
                })
            });
            const result = await res.json();
            if (result.status === 'SUCCESS') {
                alert('Comment sent successfully');
                commentref.current.value = '';
                window.location.reload();
            } else {
                alert('Something went wrong');
            }
        } catch (err) {
            console.error(err);
        }
    };

    if (isLoading) return <div className="d-flex align-items-center justify-content-center vh-100"><p>Loading...</p></div>;

    if (!data) return <div className='d-flex align-items-center justify-content-center vh-100'><p>No Data Found</p></div>;

    // Handle both possible structures ("articledata" or "article")
    const articledata = data.articledata || data.article || {};
    const relatedarticledata = data.relatedarticledata || [];
    const categoryarticle = data.categoryarticle || [];
    const ads = data.ads || [];

    const { 
        image, 
        description, 
        title, 
        video = "", 
        comments = [], 
        views = 0, 
        postid, 
        hashtags = [], 
        categoryurl = "news", 
        categorytitle = "News" 
    } = articledata;

    const showVideoPlayer = videoCategories.includes(categoryurl) || (video && video !== "");

    return (
        <>
            <Meta metadata={data.metadata} />

            <section className='article pt-1'>
                <Container>
                    <Row className='article-row'>
                        <Col>
                            {/* Video or Image */}
                            {showVideoPlayer ? (
                                <div className='video-section mb-3'>
                                    <iframe 
                                        height="500" 
                                        width="100%" 
                                        src={(video || '') + '?autoplay=1'} 
                                        frameBorder="0" 
                                        allow="autoplay" 
                                        title={title}
                                    />
                                </div>
                            ) : (
                                image && <img src={image} alt={title} className="img-fluid" />
                            )}

                            <div className='description pt-2'>
                                <div className='whitetitle'>
                                    <h1>{title}</h1>
                                </div>
                                <p>{relativeTime} | {views} Views</p>

                              <div>
  {description && parse(description)}

  {hashtags && hashtags.length > 0 && (
    hashtags.map((tag, i) => (
      <a key={i} href={`${BASE_PATH}search/${tag.keyword}`}>
        #{tag.title}&nbsp;&nbsp;
      </a>
    ))
  )}
</div>
                            </div>
                   <div className="emoji-reactions" style={{ display: 'flex', gap: '10px' }}>

                <span onClick={() => handleReaction("love")} style={{ cursor: "pointer" }}>
                    ❤️ {reactions.love}
                </span>

                <span onClick={() => handleReaction("laugh")} style={{ cursor: "pointer" }}>
                    😂 {reactions.laugh}
                </span>

                <span onClick={() => handleReaction("surprised")} style={{ cursor: "pointer" }}>
                    😮 {reactions.surprised}
                </span>

                <span onClick={() => handleReaction("sad")} style={{ cursor: "pointer" }}>
                    😢 {reactions.sad}
                </span>

                <span onClick={() => handleReaction("angry")} style={{ cursor: "pointer" }}>
                    😡 {reactions.angry}
                </span>

                </div>

                            {/* Comments */}
                            <div className='p-3 border rounded my-3'>
                                <h6>Top Comments</h6>
                                <InputGroup className="mb-3">
                                    <Form.Control 
                                        ref={commentref} 
                                        placeholder='Write a comment' 
                                    />
                                    <InputGroup.Text onClick={sendComment} style={{ cursor: 'pointer' }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="red" className="bi bi-send" viewBox="0 0 16 16">
                                            <path d="M15.854.146a.5.5 0 0 1 .11.54l-5.819 14.547a.75.75 0 0 1-1.329.124l-3.178-4.995L.643 7.184a.75.75 0 0 1 .124-1.33L15.314.037a.5.5 0 0 1 .54.11ZM6.636 10.07l2.761 4.338L14.13 2.576 6.636 10.07Zm6.787-8.201L1.591 6.602l4.339 2.76 7.494-7.493Z" />
                                        </svg>
                                    </InputGroup.Text>
                                </InputGroup>

                                {comments.length > 0 ? (
                                    comments.map((c, i) => (
                                        <div key={i} className='d-flex'>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-person-circle" viewBox="0 0 16 16">
                                                <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" />
                                            </svg>
                                            <p className='ps-2'>{c.comment}</p>
                                        </div>
                                    ))
                                ) : (
                                    <p>There are no comments yet. Be the first!</p>
                                )}
                            </div>

                            <Share shareUrl={window.location.href} title={title} />
                        </Col>
                    </Row>
                </Container>
            </section>

            {ads.length > 0 && <HorizontalAd adslot={ads[1]?.adslot} adsizes={ads[1]?.adsizes} adnumber={ads[1]?.adnumber} />}
            
            {relatedarticledata.length > 0 && (
                <RealtedArticel 
                    title={relatedtitle} 
                    url={categoryurl}
                >
                    {relatedarticledata}
                </RealtedArticel>
            )}

            {ads.length > 0 && <HorizontalAd adslot={ads[2]?.adslot} adsizes={ads[2]?.adsizes} adnumber={ads[2]?.adnumber} />}

            {categoryarticle.length > 0 && (
                <WhiteStorieCard 
                    title={trendingtitle} 
                    url={categoryurl}
                >
                    {categoryarticle}
                </WhiteStorieCard>
            )}

            {ads.length > 0 && <HorizontalAd adslot={ads[3]?.adslot} adsizes={ads[3]?.adsizes} adnumber={ads[3]?.adnumber} />}
        </>
    );
};

export default Article;